// extracted by mini-css-extract-plugin
module.exports = {"ModalBG":"style_ModalBG__3z_zh","Modal":"style_Modal__26BlH","close":"style_close__-Bci3"};